import React from "react";

/**
 * Sidebar component with chat list
 * @param {Object} props
 * @param {Array<string>} props.sessionIds - List of session IDs
 * @param {Object} props.sessionTitles - Map of session IDs to titles
 * @param {Object} props.sessionUserEmails - Map of session IDs to user emails
 * @param {boolean} props.isAdmin - Whether current user is admin
 * @param {string|null} props.currentSessionId - Currently selected session ID
 * @param {Function} props.onSessionSelect - Handler for session selection
 * @param {Function} props.onNewChat - Handler for creating new chat
 * @param {boolean} props.isStartingSession - Whether a session is being started
 */
const Sidebar = ({
  sessionIds,
  sessionTitles,
  sessionUserEmails,
  isAdmin,
  currentSessionId,
  onSessionSelect,
  onNewChat,
  isStartingSession,
}) => {
  return (
    <nav className="sidebar">
      <div className="logo">
        <h1>
          VAMOOS <span style={{ color: "white" }}>STUDIO</span>
        </h1>
      </div>
      <div className="chat-list-header">
        <h3>Chats</h3>
        <button
          className="new-chat-btn"
          onClick={onNewChat}
          disabled={isStartingSession}
          title="Start New Chat Session"
        >
          {isStartingSession ? "..." : "+"}
        </button>
      </div>
      <ul className="chat-list">
        {sessionIds.length === 0 && (
          <li className="chat-item">
            <div className="chat-avatar">💬</div>
            <div className="chat-info">
              <div className="chat-name">No chats yet</div>
              <div className="chat-preview">Start a new chat to begin</div>
            </div>
          </li>
        )}
        {sessionIds.map((sid) => (
          <li
            key={sid}
            className={`chat-item ${currentSessionId === sid ? "active" : ""}`}
            onClick={() => onSessionSelect(sid)}
            style={{ cursor: "pointer" }}
          >
            <div className="chat-avatar">🗂️</div>
            <div className="chat-info">
              <div className="chat-name">
                {sessionTitles[sid] || "Untitled Project"}
              </div>
              <div className="chat-preview">
                {isAdmin && sessionUserEmails[sid]
                  ? `User: ${sessionUserEmails[sid]}`
                  : "Click to open chat"}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Sidebar;
